import dayjs from 'dayjs';
import type { JournalEntry, JournalEntryLine } from '@vy/types';

export type JournalEntryRow = JournalEntryLine & {
  id: string;
  journalEntryKey: string;
  periodMonth: string;
  periodLabel: string;
  periodDate: string;
  description: string;
};

export function flattenJournalEntries(entries: JournalEntry[]): JournalEntryRow[] {
  return entries.flatMap((entry) => {
    const entryDate = dayjs(entry.date);
    const periodMonth = entryDate.format('YYYY-MM');
    const periodLabel = entryDate.format('MMM YYYY');
    const periodDate = entryDate.format('MM/DD/YYYY');
    const entryCustomerName = entry.lines[0]?.customerName ?? '';
    const description = `${entryDate.format('MM/DD/YYYY')} - ${entryCustomerName}`;
    const journalEntryKey = `${entry.accountId}|${entry.lines[0]?.customerId ?? ''}|${entryDate.format('YYYY-MM-DD')}`;

    return entry.lines.map((line) => {
      const id = `${journalEntryKey}|${line.account}`;
      return {
        ...line,
        id,
        journalEntryKey,
        periodMonth,
        periodLabel,
        periodDate,
        description,
      };
    });
  });
}
